import { Component } from '@angular/core';
import { PaEmptyListComponent } from 'src/app/shared/ui-kit/pa-empty-list/pa-empty-list.component';

@Component({
  selector: 'app-empty-list-view',
  standalone: true,
  imports: [PaEmptyListComponent],
  templateUrl: './empty-list-view.component.html',
  styleUrls: ['./empty-list-view.component.scss'],
})
export class EmptyListViewComponent {} 